import { Injectable } from '@angular/core';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

@Injectable()
export abstract class AbstractTrackEventsService {
  abstract trackEvent(event: Record<string, unknown>): void;
}
